import requestAction from '../../utils/requestAction'

export const fetchProduct = (productId: string) =>
  requestAction('PRODUCT_DETAIL')(`products/${productId}`, 'GET')
